import { useMemo } from 'react';
import { buildStartupScreenMarkup, type IStartupScreenMarkupOptions } from './startupScreenMarkup';

// Ту же разметку приложение встраивает в index.html до загрузки JavaScript (startupScreenHtmlPlugin), стили
// экрана подключает там же — здесь они не импортируются.

export interface IStartupScreenProps extends IStartupScreenMarkupOptions {
    /** Внутри раскладки приложения: без шапки, на фоне контента */
    withinLayout?: boolean;
}

const StartupScreen = ({ logoSrc, logoColorSrc, logoBadgeHtml, withinLayout = false }: IStartupScreenProps) => {
    // Стабильный объект сохраняет DOM и фазу анимации при повторных рендерах App.
    const markup = useMemo(
        () => ({ __html: buildStartupScreenMarkup({ logoSrc, logoColorSrc, logoBadgeHtml }) }),
        [logoSrc, logoColorSrc, logoBadgeHtml],
    );
    return (
        <div
            className={withinLayout ? 'app-startup app-startup--content' : 'app-startup'}
            dangerouslySetInnerHTML={markup}
        />
    );
};

export default StartupScreen;
